module.exports = __webpack_public_path__ + "media/images/emblems/Schlatt-Haslen-Wappen-5ed8b44844794d2a353461a6517851e4.png";